import styled from 'styled-components';
import { Caption, mq } from '@kvdbil/components';

export const ElectricCarGrantFormContainer = styled.div`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
  margin-bottom: 2rem;
`;

export const SubmitButtonWrapper = styled.div`
  margin-top: 1.5rem;
`;

export const ResultContainer = styled.section`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid ${({ theme }) => theme.colors.grayscaleToned.light1};
`;

export const BulletList = styled.ul`
  padding-left: 1rem;
  font-family: ${({ theme }) => theme.typography.fontBaseFamily};
  font-size: 1rem;
  line-height: 1.5;
  list-style-type: disc;
`;

export const ElectricCarGrantFormContent = styled.form`
  border: 1px solid ${({ theme }) => theme.colors.primary.main};
  padding: 1rem;

  ${mq('tablet')} {
    padding: 2rem;
  }
`;

export const ElectricCarGrantHelperText = styled(Caption)`
  color: ${({ theme }) => theme.colors.grayscaleToned.dark3};
`;

export const NoWrapSpan = styled.span`
  white-space: nowrap;
`;
